import AppCommandBar from 'app/AppCommandBar'
import {
  DayPickerStrings,
  FlexSpinner,
  GraphQLDatePicker,
  onFormatDate,
  ProvingGroundDropdownWithoutAbbr,
} from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { useCommand } from 'hooks/useCommand'
import { useEqVehicleModelDropdownQuery } from 'hooks/useEqVehicleModels.generated'
import { UserRole } from 'model'
import { DayOfWeek, Dropdown, Stack, TextField } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Section } from 'views/ProvingDetailsView/Layout'
import { SynergyList } from './SynergyList'
import { useSynergiesLazyQuery } from './SynergyView.generated'

// TODO: Oracle DB View erweitern um Ausstattungsmerkmale
// TODO: Ausstattungsmerkmalsuche hinzufügen

export const SynergyView: React.FC = () => {
  const { t } = useTranslation()
  const [load, { loading, data, error }] = useSynergiesLazyQuery()

  const items = data && data.synergies ? data.synergies : []

  const [getDepartment, setDepartment] = React.useState()
  const [getProvingGround, setProvingGround] = React.useState()
  // const [vehicleType, setVehicleType] = React.useState()
  const [getVehicleModel, setVehicleModel] = React.useState()
  const [getVehicleDerivative, setVehicleDerivative] = React.useState()
  const [getInternalLabel, setInternalLabel] = React.useState()
  const [getLicensePlate, setLicensePlate] = React.useState()
  const [getModelYear, setModelYear] = React.useState()
  // const [getResource, setResource] = React.useState()
  const [getDateFrom, setDateFrom] = React.useState()
  const [getDateTo, setDateTo] = React.useState()
  // const resources = useReadAllResourcesQuery()

  // const alltheresources = (resources.data && resources.data.resources) || []

  // const allTheTags = alltheresources.map((bla: any) => ({
  //   key: bla._id,
  //   name: bla.title,
  // })) as ITag[]

  const modelQuery = useEqVehicleModelDropdownQuery()

  const modelOptions = React.useMemo(
    () =>
      !modelQuery.loading && modelQuery.data
        ? modelQuery.data.eqVehicleModels
            .sort()
            .filter((x) => x !== null)
            .map((m) => ({
              key: m.type,
              text: `${m.type} ${
                m.typeDescription ? `(${m.typeDescription})` : ''
              }`,
            }))
        : [],
    [modelQuery.loading, modelQuery.data]
  )
  if (modelOptions) {
    let isdrin = false
    if (modelOptions.find((x) => x.key === '')) {
      isdrin = true
    }
    if (isdrin === false) {
      modelOptions.unshift({ key: '', text: '' })
    }
  }

  const loadMatches = (
    department: string,
    provingGround: string,
    vehicleModel: string,
    vehicleDerivative: string,
    internalLabel: string,
    licensePlate: string,
    modelYear: string,
    // resource: string,
    dateFrom: string,
    dateTo: string
  ) => {
    load({
      variables: {
        department,
        provingGround,
        vehicleModel,
        vehicleDerivative,
        internalLabel,
        licensePlate,
        modelYear,
        // resource,
        dateFrom,
        dateTo,
      },
    })
  }

  useCommand(
    {
      key: 'synergySearch',
      priority: 10,
      text: 'Synergien suchen',
      iconProps: { iconName: 'SyncOccurence' },
      onClick: () => {
        loadMatches(
          getDepartment,
          getProvingGround,
          getVehicleModel,
          getVehicleDerivative,
          getInternalLabel,
          getLicensePlate,
          getModelYear,
          // getResource,
          getDateFrom,
          getDateTo
        )
      },
    },
    [
      getDepartment,
      getProvingGround,
      getVehicleModel,
      getVehicleDerivative,
      getInternalLabel,
      getLicensePlate,
      getModelYear,
      // getResource,
      getDateFrom,
      getDateTo,
    ]
  )

  return (
    <>
      <ViewAuthorizer
        roles={[
          UserRole.SystemAdministrator,
          UserRole.Reader,
          UserRole.ProvingOrganisation,
          UserRole.ResourceManager,
          UserRole.ProvingCreator,
          UserRole.User,
        ]}
      >
        <StickyPane>
          <AppCommandBar />
          <Section label="Suchangaben">
            <Stack
              horizontal={true}
              horizontalAlign="center"
              tokens={{ childrenGap: 8 }}
            >
              <Stack verticalFill={true} grow={1}>
                <Stack.Item>
                  <Section label="Grunddaten">
                    <ProvingGroundDropdownWithoutAbbr
                      id="provingGroundId"
                      label={t('field.provingGround.label')}
                      onChange={(_, newValue) => {
                        const selectedProvingGround = newValue && newValue.text
                        setProvingGround(newValue!.text)
                        loadMatches(
                          getDepartment,
                          selectedProvingGround || '',
                          getVehicleModel,
                          getVehicleDerivative,
                          getInternalLabel,
                          getLicensePlate,
                          getModelYear,
                          // getResource,
                          getDateFrom,
                          getDateTo
                        )
                      }}
                    />
                    {/* <TextField
                  name="provingGround"
                  label="Erprobungsstandort"
                  onChange={(_, newValue) => setProvingGround(newValue)}
                  onKeyDown={_ =>
                    load({
                      variables: {
                        department,
                        provingGround,
                        // vehicleType,
                        vehicleModel,
                        vehicleDerivative,
                        internalLabel,
                        licensePlate,
                        modelYear,
                        resource,
                        dateFrom,
                        dateTo,
                      },
                    })
                  }
                /> */}
                    <TextField
                      label="Abteilung"
                      name="department"
                      onChange={(_, newValue) => {
                        setDepartment(newValue)
                        loadMatches(
                          newValue || '',
                          getProvingGround,
                          getVehicleModel,
                          getVehicleDerivative,
                          getInternalLabel,
                          getLicensePlate,
                          getModelYear,
                          // getResource,
                          getDateFrom,
                          getDateTo
                        )
                      }}
                    />
                    {/* <TagPicker
                  itemLimit={1}
                  onResolveSuggestions={filter => {
                    return (alltheresources || [])
                      .filter(x =>
                        x.title.toLowerCase().includes(filter.toLowerCase())
                      )
                      .map(y => {
                        return { key: y._id, name: y.title } as ITag
                      })
                  }}
                  onChange={newValue => {
                    setResource(newValue && newValue[0] && newValue[0].name)
                    load({
                      variables: {
                        department,
                        provingGround,
                        // vehicleType,
                        vehicleModel,
                        vehicleDerivative,
                        internalLabel,
                        licensePlate,
                        modelYear,
                        resource,
                        dateFrom,
                        dateTo,
                      },
                    })
                  }}
                /> */}

                    {/* <TextField
                      label="Ressource"
                      name="resource"
                      onChange={(_, newValue) => {
                        setResource(newValue)
                        loadMatches(
                          getDepartment,
                          getProvingGround,
                          getVehicleModel,
                          getVehicleDerivative,
                          getInternalLabel,
                          getLicensePlate,
                          getModelYear,
                          newValue || '',
                          getDateFrom,
                          getDateTo
                        )
                      }}
                    /> */}
                    <GraphQLDatePicker
                      label="Von"
                      firstDayOfWeek={DayOfWeek.Monday}
                      formatDate={onFormatDate as any}
                      strings={DayPickerStrings}
                      showWeekNumbers={true}
                      value={getDateFrom}
                      onSelectDate={(newValue) => {
                        setDateFrom(newValue)
                        loadMatches(
                          getDepartment,
                          getProvingGround,
                          getVehicleModel,
                          getVehicleDerivative,
                          getInternalLabel,
                          getLicensePlate,
                          getModelYear,
                          // getResource,
                          newValue || '',
                          getDateTo
                        )
                      }}
                    />
                    <GraphQLDatePicker
                      label="Bis"
                      value={getDateTo}
                      firstDayOfWeek={DayOfWeek.Monday}
                      formatDate={onFormatDate as any}
                      strings={DayPickerStrings}
                      showWeekNumbers={true}
                      disabled={!getDateFrom}
                      minDate={new Date(getDateFrom)}
                      initialPickerDate={new Date(getDateFrom)}
                      onSelectDate={(newValue) => {
                        setDateTo(newValue)
                        loadMatches(
                          getDepartment,
                          getProvingGround,
                          getVehicleModel,
                          getVehicleDerivative,
                          getInternalLabel,
                          getLicensePlate,
                          getModelYear,
                          // getResource,
                          getDateFrom,
                          newValue || ''
                        )
                      }}
                    />
                  </Section>
                </Stack.Item>
              </Stack>
              <Stack.Item grow={1} verticalFill={true}>
                <Section label="Fahrzeugdaten">
                  {/* <Dropdown
              label="Fahrzeugtyp"
              options={modelOptions}
              onChange={(_, newValue) => setVehicleType(newValue!.text)}
            /> */}
                  <Dropdown
                    label="Fahrzeugmodell"
                    options={modelOptions}
                    onChange={(_, newValue) => {
                      setVehicleModel(newValue!.text)
                      loadMatches(
                        getDepartment,
                        getProvingGround,
                        (newValue && newValue.text) || '',
                        getVehicleDerivative,
                        getInternalLabel,
                        getLicensePlate,
                        getModelYear,
                        // getResource,
                        getDateFrom,
                        getDateTo
                      )
                    }}
                  />
                  <TextField
                    label="Derivat"
                    name="vehicleDerivative"
                    onChange={(_, newValue) => {
                      setVehicleDerivative(newValue)
                      loadMatches(
                        getDepartment,
                        getProvingGround,
                        getVehicleModel,
                        newValue || '',
                        getInternalLabel,
                        getLicensePlate,
                        getModelYear,
                        // getResource,
                        getDateFrom,
                        getDateTo
                      )
                    }}
                  />
                  <TextField
                    label="Int. Bezeichnung"
                    name="internalLabel"
                    onChange={(_, newValue) => {
                      setInternalLabel(newValue)
                      loadMatches(
                        getDepartment,
                        getProvingGround,
                        getVehicleModel,
                        getVehicleDerivative,
                        newValue || '',
                        getLicensePlate,
                        getModelYear,
                        // getResource,
                        getDateFrom,
                        getDateTo
                      )
                    }}
                  />

                  <TextField
                    label="Kennzeichen"
                    name="licensePlate"
                    onChange={(_, newValue) => {
                      setLicensePlate(newValue)
                      loadMatches(
                        getDepartment,
                        getProvingGround,
                        getVehicleModel,
                        getVehicleDerivative,
                        getInternalLabel,
                        newValue || '',
                        getModelYear,
                        // getResource,
                        getDateFrom,
                        getDateTo
                      )
                    }}
                  />
                  <TextField
                    label="Modelljahr"
                    name="modelYear"
                    onChange={(_, newValue) => {
                      setModelYear(newValue)
                      loadMatches(
                        getDepartment,
                        getProvingGround,
                        getVehicleModel,
                        getVehicleDerivative,
                        getInternalLabel,
                        getLicensePlate,
                        newValue || '',
                        // getResource,
                        getDateFrom,
                        getDateTo
                      )
                    }}
                  />
                </Section>
              </Stack.Item>
              {/* <Stack.Item grow={1} verticalFill={true}>
                <Section label="Zeitraum">
                  <GraphQLDatePicker
                    label="Von"
                    firstDayOfWeek={DayOfWeek.Monday}
                    formatDate={onFormatDate as any}
                    strings={DayPickerStrings}
                    showWeekNumbers={true}
                    value={dateFrom}
                    onSelectDate={newValue => {
                      setDateFrom(newValue)
                      load({
                        variables: {
                          department,
                          provingGround,
                          // vehicleType,
                          vehicleModel,
                          vehicleDerivative,
                          internalLabel,
                          licensePlate,
                          modelYear,
                          resource,
                          dateFrom,
                          dateTo,
                        },
                      })
                    }}
                  />
                  <GraphQLDatePicker
                    label="Bis"
                    value={dateTo}
                    firstDayOfWeek={DayOfWeek.Monday}
                    formatDate={onFormatDate as any}
                    strings={DayPickerStrings}
                    showWeekNumbers={true}
                    onSelectDate={newValue => {
                      setDateTo(newValue)
                      load({
                        variables: {
                          department,
                          provingGround,
                          // vehicleType,
                          vehicleModel,
                          vehicleDerivative,
                          internalLabel,
                          licensePlate,
                          modelYear,
                          resource,
                          dateFrom,
                          dateTo,
                        },
                      })
                    }}
                  />
                </Section>
              </Stack.Item> */}
            </Stack>
          </Section>
          <FlexSpinner loading={loading} error={error}>
            <SynergyList items={items} />
          </FlexSpinner>
        </StickyPane>
      </ViewAuthorizer>
    </>
  )
}
